import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import Button from "../Nano/Buttons/Button.js";
import Type from "../Global/Typography.js";
import { ReactComponent as DeleteWarning } from "../Global/Icons/delete.svg";

const ModalContentStyle = styled.div`
  padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .modalContainer {
    max-width: 350px;
    .modalTitle {
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      .modalIcon {
        width: 25px;
        height: 25px;
        margin-right: ${nota.global.multiple * 2 + "px"}; /*16px*/
        path {
          fill: ${nota.color.main.mTwo};
        }
      }
    }
    .infoContainer {
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      padding-top: 0;
      max-height: 500px;
      min-height: 100px;
      overflow: auto;
      text-align: center;
    }
    .btnsContainer {
      height: 50px;
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      padding-bottom: 0;
      margin: 0;
      border-top: 0.5px solid ${nota.color.neutral.NeuTwo};
    }
  }
`;

const ModalContent = (props) => {
  return (
    <ModalContentStyle>
      <NanoFlex className="modalContainer" flexDirection={"column"} flexWrap={"wrap-reverse"} justifyContent={"space-around"} alignContent={"center"}>
        {props.title && (
          <NanoFlex className="modalTitle" justifyContent={"flex-start"} alignItems={"flex-end"}>
            {/* <DeleteWarning className="modalIcon" /> */}
            <Type.h2>{props.title}</Type.h2>
          </NanoFlex>
        )}
        <NanoFlex className="infoContainer">
          <Type.p>{props.message}</Type.p>
        </NanoFlex>
        {props.actions?.length > 0 && (
          <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
            {props.actions.map((item) => {
              return <Button key={item.label} label={item.label} clickAction={item.action} simple={item.simple} />;
            })}
          </NanoFlex>
        )}
      </NanoFlex>
    </ModalContentStyle>
  );
};

// Set default props
ModalContent.defaultProps = {
  title: "",
  message: "",
  actions: [],
};

export default ModalContent;

/*
Doc
import ModalContent from '../../Micro/ModalContent.js';

<ModalContent
    title={"Title Test"}
    message={"Message Test"}
    actions={[{label: "Continue", action: () => { <Code Here..> }, simple: false}]}
/>
*/
